// Function to check if a class exists
function checkClassExistence(className) {
    return document.getElementsByClassName(className).length > 0;
}
// Function to wait for a specific div with a specific class
function waitForDiv(className, callback) {
    // Check if the class already exists
    if (checkClassExistence(className)) {
        callback();
        return;
    }
    // Otherwise, create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(mutationsList => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check if the class now exists
                if (checkClassExistence(className)) {
                    callback();
                    observer.disconnect(); // Disconnect the observer once the class appears
                    return;
                }
            }
        }
    });
    // Start observing the target node for configured mutations
    observer.observe(document.body, { childList: true, subtree: true });
}
// Example usage: Wait for a div with class 'specific-class' and then execute a callback
waitForDiv('rc-template__legacy-radio', function() {
    console.log("The div with class 'specific-class' exists now.");
    var checkedInput = document.querySelector('.product-form__input input:checked');
    if (checkedInput) {
      setTimeout(() => {
        var checkedValue = checkedInput.value;
        console.log('checkedValue',checkedValue);
        document.querySelector('[data-price-subsave]').innerHTML += " <u></u>" + checkedValue;
        document.querySelector('[data-price-onetime]').innerHTML += " <u></u>" + checkedValue;  
      }, 300)
    }
    var d1 = document.querySelector('.rc-template__legacy-radio');
    d1.insertAdjacentHTML('afterbegin', '<div class="variant-block--heading"><h6>Save More with a Subscription:</h6></div>');
  // Select the element you want to add the class to
    var element = document.querySelector(".rc-template__legacy-radio");
    element.classList.add("product-inner-box");
    updateSpecialContent();
    setTimeout(() => {
    document.querySelectorAll('.rc-option__subsave input, .rc-option__onetime input').forEach(function(input) {
      input.addEventListener('change', function() {
        updateSpecialContent();
      });
    });
    }, 1000);

    // Subscription Benefits
    const targetElement = document.querySelector(".rc-radio.rc-option__subsave.rc-option.rc_widget__option.rc_widget__option--subsave.rc-legacy-radio .rc_widget__option__selector");
    const newItem = document.createElement("div");
    newItem.classList.add("subscription-benefits");

  
    // Create a ul element with 3 li elements
    const newList = document.createElement("ul");
  
    const listItem1 = document.createElement("li");
    listItem1.textContent = "15% Discount on Every Order"; 
    newList.appendChild(listItem1);
  
    const listItem2 = document.createElement("li");
    listItem2.textContent = "Guaranteed Delivery During Sell-Outs"; 
    newList.appendChild(listItem2);
  
    const listItem3 = document.createElement("li");
    listItem3.textContent = "Pause, Update Frequency or Cancel Anytime "; 
    newList.appendChild(listItem3);
  
    newItem.appendChild(newList);
  
    if (targetElement) {
      targetElement.appendChild(newItem);
    } else {
      console.log("Target element not found.");
    }
});

var checkedInput = document.querySelector('.product-form__input input:checked');
if (checkedInput) {
  var checkedValue = checkedInput.value;
  var stickyVariantCartText = document.querySelector('.selected-feature-variant');
  if (stickyVariantCartText) {
    stickyVariantCartText.textContent = checkedValue;
  }
  document.querySelector('.product-variant-box').classList.remove('active');
  document.querySelectorAll('.product-variant-box').forEach(function(box) {
    var selectVarName = box.querySelector('p').getAttribute('data-var');
    if (selectVarName === checkedValue) {
      box.classList.add('active');
    }
  });
}

function isSubscribed() {
    const oneTimeInput = document.querySelector('.rc-option__onetime input');
    return !oneTimeInput || oneTimeInput.checked === false;
    console.log('oneTimeInput',oneTimeInput);
  }

function updateSpecialContent() {
  var productFormVariants = document.querySelector('.product-form');
  if (isSubscribed()) {
    setTimeout(() => {
      var varPriceText = productFormVariants.querySelector('.rc_widget__price--subsave').textContent;
      var varPrice = varPriceText?.replace(/\d+-Pack/, '').trim() || '';
      var newStr = varPrice.replace('$','');
      var varPriceNum = Number(newStr);
      var totalPrice = varPriceNum / 4;
      var totalFloor = totalPrice.toFixed(2);
      
      document.querySelector('.product-form__buttons .reg-price').textContent = varPrice;
      var stickyPlan = document.querySelector('.feature-sticky-subscription--wrapper span');
      productFormVariants.classList.add('subscribed');
      productFormVariants.classList.remove('one-time');
      if(stickyPlan){        
        stickyPlan.innerHTML = 'Subscribe & save';
      }
      var shopPay = document.querySelector('.product-shop-pay-box');
      if(shopPay){
        document.querySelector('.product-shop-pay-box span').innerHTML = totalFloor;
      }

      var variantElements = document.querySelectorAll('.product-variant-box');
      variantElements.forEach(function(element) {
        var originalPrice = parseFloat(element.getAttribute('data-price'));
        var discountedPrice = (originalPrice * 0.85).toFixed(2);
        var variantTitle = element.querySelector('p').getAttribute('data-var');
        var variantPack = variantTitle.replace(/-pack/i, "");
        var discountedPriceNum = Number(discountedPrice);
        var variantPackNum = Number(variantPack);
        var variantPerBath = (discountedPriceNum / variantPackNum).toFixed(2);
        var perBathElement = element.querySelector('.perbatn-val');
        if (perBathElement) {
          perBathElement.textContent = '$' + variantPerBath + '/bath';
        }
        var variantId = element.getAttribute('data-id');
        var stickyVarElement = document.querySelector('.feature-sticky-variant-box--wrapper ul li[data-id="' + variantId + '"] b');
        if (stickyVarElement) {
          stickyVarElement.textContent = '$' + variantPerBath + '/bath';
        }
      });
      
      var checkedInput = document.querySelector('.product-form__input input:checked');
      if (checkedInput) {
        var checkedValue = checkedInput.value;
        var checkedNumVal = checkedValue.replace(/-pack/i, "");
        var varValNum = Number(checkedNumVal);
        var perBath = varPriceNum / varValNum;
        var perBathlFloor = perBath.toFixed(2);
        document.querySelector('.feature-sticky-variant-box--wrapper b').textContent = '$'+perBathlFloor+'/bath';        
      }
    }, 1000);
  } else {
    setTimeout(() => {
      var varPriceText = productFormVariants.querySelector('.rc_widget__price--onetime').textContent;
      var varPrice = varPriceText?.replace(/\d+-Pack/, '').trim() || '';
      var newStr = varPrice.replace('$','');
      var varPriceNum = Number(newStr);
      var totalPrice = varPriceNum / 4;
      var totalFloor = totalPrice.toFixed(2);
      productFormVariants.classList.add('one-time');
      productFormVariants.classList.remove('subscribed');
      document.querySelector('.product-form__buttons .reg-price').textContent = varPrice;
      var stickyPlan = document.querySelector('.feature-sticky-subscription--wrapper span');
      if(stickyPlan){        
        stickyPlan.innerHTML = 'One-time';
      }
      var shopPay = document.querySelector('.product-shop-pay-box');
      if(shopPay){
        document.querySelector('.product-shop-pay-box span').innerHTML = totalFloor;
      }

      var variantElements = document.querySelectorAll('.product-variant-box');
      variantElements.forEach(function(element) {
        var originalPrice = parseFloat(element.getAttribute('data-price'));
        var variantTitle = element.querySelector('p').getAttribute('data-var');
        var variantPack = variantTitle.replace(/-pack/i, "");
        var originalPriceNum = Number(originalPrice);
        var variantPackNum = Number(variantPack);
        var variantPerBath = (originalPriceNum / variantPackNum).toFixed(2);
        var perBathElement = element.querySelector('.perbatn-val');
        if (perBathElement) {
          perBathElement.textContent = '$' + variantPerBath + '/bath';
        }
        var variantId = element.getAttribute('data-id');
        var stickyVarElement = document.querySelector('.feature-sticky-variant-box--wrapper ul li[data-id="' + variantId + '"] b');
        if (stickyVarElement) {
          stickyVarElement.textContent = '$' + variantPerBath + '/bath';
        }
      });
      
      var checkedInput = document.querySelector('.product-form__input input:checked');
      if (checkedInput) {
        var checkedValue = checkedInput.value;
        var checkedNumVal = checkedValue.replace(/-pack/i, "");
        var varValNum = Number(checkedNumVal);
        var perBath = varPriceNum / varValNum;
        var perBathlFloor = perBath.toFixed(2);
        document.querySelector('.feature-sticky-variant-box--wrapper b').textContent = '$'+perBathlFloor+'/bath';
        document.querySelector('.product-variant-box.active .perbatn-val').textContent = '$'+perBathlFloor+'/bath';
      }
    }, 1000);
  }
}